import { render, staticRenderFns } from "./register.vue?vue&type=template&id=2289af3c&scoped=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"
import style0 from "./register.vue?vue&type=style&index=0&id=2289af3c&prod&scoped=true&lang=scss"
import style1 from "./register.vue?vue&type=style&index=1&id=2289af3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2289af3c",
  null
  
)

export default component.exports